document.addEventListener("DOMContentLoaded", function () {
  const ogButtons = document.querySelectorAll(".ordergroove-option");
  const ogSelectFrequency = document.querySelector("og-select-frequency");

  if (ogSelectFrequency) {
    const ogSelect = ogSelectFrequency.shadowRoot.querySelector("og-select");
    ogSelect.style.width = "100%";

    const ogArrow = ogSelect.shadowRoot.querySelector("span");
    ogArrow.style.display = "none";

    const select = ogSelect.shadowRoot.querySelector("select");
    select.style.padding = "0 10px 5px 10px";

    ogButtons.forEach((ogButton) => {
      const shadowRoot = ogButton.shadowRoot;
      const buttonInside = shadowRoot.querySelector("button");

      ogButton.style.marginTop = "0";
      ogButton.style.padding = "5px 0";

      // Base button styles
      buttonInside.style.backgroundColor = "#DDDDDD";
      buttonInside.style.color = "white";
      buttonInside.style.width = "16px";
      buttonInside.style.height = "16px";
      buttonInside.style.border = "0";

      // Inject style once inside the shadowRoot
      const style = document.createElement("style");
      style.textContent = `
        button.active::after {
          content: '';
          display: block;
          width: 100%;
          height: 100%;
          border: 5px solid #EB3986 !important;
          background: #ffffff !important;
        }
      `;
      shadowRoot.appendChild(style);

      // Add click listener to each button
      buttonInside.addEventListener("click", () => {
        // Remove "active" class from all buttons
        ogButtons.forEach((otherOgButton) => {
          const otherShadowRoot = otherOgButton.shadowRoot;
          const otherButton = otherShadowRoot.querySelector("button");
          otherButton.classList.remove("active");
        });

        // Add "active" class to clicked button
        buttonInside.classList.add("active");
      });
    });
  }
});
